let headers: Record<string, any> = { 'new-cart': '1', 'x-web': 'true' };

// NOTE: x-web header is sent as string true
export const setNewCartHeaders = () => (headers = { 'new-cart': '1', 'x-web': 'true' });

export const getNewCartHeader = () => {
  return headers;
};
